// AUTOGENERATED BY FUNCTION genubamodel.js
export interface AdvanceSetupCommand extends CommandBase {
  data?: AdvanceSetup;
  clientId?: string;
}

export interface ApiKeyCommand extends CommandBase {
  data?: ApiKey;
}

export interface ApiKeyCommandResponse {
  apiKey?: ApiKey;
  plainSecret?: string;
}

export interface CcxEnrollmentCommand extends CommandBase {
  data?: CcxEnrollment;
}

export interface ClientServiceProfileCommand extends CommandBase {
  data?: ClientServiceProfile;
}

export interface ClientServiceProfilePriorityCommand extends CommandBase {
  data?: ClientServiceProfilePriority;
}

export interface ClientServiceProfileTenuousRecordCommand extends CommandBase {
  data?: ClientServiceProfileTenuousRecord;
}

export interface ClientSpecialHandlingNoteCommand extends CommandBase {
  data?: ClientSpecialHandlingNote;
}

export interface CustomizationCommand extends CommandBase {
  data?: Customization;
}

export interface DepletionOrderCommand extends CommandBase {
  data?: DepletionOrder;
}

export interface DeviceCommand extends CommandBase {
  data?: Device;
}

export interface AgencyClientCommand extends CommandBase {
  data?: AgencyClient;
}

export interface AgentClientAccessCommand extends CommandBase {
  data?: AgentClientAccess;
}

export interface AgentSupportAccessCommand extends CommandBase {
  data?: AgentSupportAccess;
}

export interface DivisionCommand extends CommandBase {
  data?: Division;
}

export interface DivisionContactCommand extends CommandBase {
  data?: DivisionContact;
}

export interface DocumentCommand extends CommandBase {
  data?: Document;
  additionalProperties?: AdditionalLetterProperties;
}

export interface DocumentDistributionCommand extends CommandBase {
  data?: DocumentDistribution;
}

export interface EmployeeEligibilityClassCommand extends CommandBase {
  data?: EmployeeEligibilityClass;
}

export interface EmploymentInfoCommand extends CommandBase {
  data?: EmploymentInfo;
}

export interface FundsTransferCriterionCommand extends CommandBase {
  data?: FundsTransferCriterion;
  additionalProperties?: AdditionalFundsTransferProperties;
}

export interface IndividualServiceProfileCommand extends CommandBase {
  data?: IndividualServiceProfile;
}

export interface PayrollCommand extends CommandBase {
  data?: Payroll;
}

export interface PayrollScheduleCommand extends CommandBase {
  data?: PayrollSchedule;
}

export interface DocumentActionCommand extends CommandBase {
  data?: DocumentAction;
}

export interface ClientAccountManagementCommand extends CommandBase {
  data?: ClientAccountManagement;
}

export interface MspReportingRequestCommand extends CommandBase {
  data?: MspReportingRequest;
}

export interface MspReportingFileCommand extends CommandBase {
  data?: MspReportingFile;
}

export interface MspResponseFileLineCommand extends CommandBase {
  data?: MspResponseFileLine;
}

export interface EligibilityEventCommand extends CommandBase {
  data?: EligibilityEvent;
  electionData?: EligibilityEventElectionData[];
  refId?: string;
}

export interface EligibilityEventOfferingCommand extends CommandBase {
  data?: EligibilityEventOffering;
  electedProfileIds?: string[];
  priceIds?: string[];
}

export interface OfferingPriceCommand extends CommandBase {
  data?: OfferingPrice;
}


export interface AgencyAuthPreferencesCommand extends CommandBase {
  data?: AgencyAuthPreferences;
}

export interface AdditionalLetterProperties {
  selectedPAGIds?: string[];
  workOrderNumber?: string;
  informationRequiredToProcess?: string;
  participantName?: string;
  showElectionPacketResend?: boolean;
  pastObligationPrices?: ObligationPricesPayload[];
  futureObligationPrices?: ObligationPricesPayload[];
  bcsRateChanges?: BcsRateChangesPayload[];
  timelineEffectiveDate?: string;
  linkedDocumentId?: string;
  futureObligationStartDate?: string;
  totalAmountDue?: string;
  remainingAmountDue?: string;
}

export interface AdditionalFundsTransferProperties {
  cabFundingPaymentDetails?: CabFundingPaymentDetail[];
}

export interface CabFundingPaymentSummary {
  clientCABFundingId?: string;
  cabFundingPaymentDetails?: CabFundingPaymentDetail[];
}

export interface CabFundingPaymentDetail {
  planId?: string;
  planName?: string;
  scheduledDate?: string;
  amountSum?: number;
}

export interface ObligationPricesPayload {
  planName: string;
  coverageLevel: string;
  paidThroughDate: string;
  dueDate: string;
  premium: string;
  initialDueDate: string;
  initialPaymentAmount: string;
  eligibilityEndDate: string;
  inactivationDate: string;
  conversionContactName?: string;
  conversionContactInfo?: string;
  startDate?: string;
}

export interface BcsRateChangesPayload {
  planName: string;
  coverageLevel: string;
  premium: string;
  effectiveDate: string;
}

export interface Address {
  id?: string;
  addressType: AddressType;
  addressLine1: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  country: string;
  zip?: string;
  zipplusfour?: string;
}

export interface AdvanceSetup extends EntityBase {
  benefitPlans: string[];
  advanceFeatureId: string;
  maxAdvanceAmount: number;
  contributionPosted: boolean;
  contributionPostingId?: string;
  effectiveDate?: string;
  newMaxAdvanceAmount?: number;
  paymentSourceId: string;
}

export interface ApiKey extends EntityBase {
  accessKey?: string;
  secret?: string;
  inactivateDate?: string;
  notes?: string;
}

export interface CcxEnrollment extends EntityBase {
  selectCarrierId: string;
  groupId: string[];
  ccxMemberId: string;
  startDate: string;
  endDate?: string;
  clientId?: string;
}

export interface ClientDivision extends EntityBase {
  clientId: string;
  divisions?: Division[];
}

export interface ClientServiceProfile extends EntityBase {
  contractStartDate?: string;
  contractEndDate?: string;
  totalEmployees?: number;
  totalEmployeesParticipating?: number;
  totalEligibleEmployees?: number;
  ichraEligibleCount?: number;
  clientAccountExecutive?: string;
  clientMinimumAvailableBalance?: number;
  clientRelationshipProfile?: string;
  isAcquisition?: boolean;
  acquisitionMethod?: AcquisitionMethodType;
  acquisitionName?: string;
  acquisitionNames?: string[];
  scheduledMigrationDate?: string;
  liveDate?: string;
  sentCommunications?: SentCommunication[];
  accountManagerId?: string;
  hasOpenEnrollment?: boolean;
  hasCarrierNotifications?: boolean;
}

export interface ClientServiceProfilePriority extends EntityBase {
  totalScore: number;
  clientType?: PriorityClientType;
  clientTypeScore?: number;
  isVIC?: boolean;
  vicScore?: number;
  isTenuous?: boolean;
  tenuousCreatedBy?: string;
  tenuousDuration?: number;
  tenuousStartDate?: string;
  tenuousEndDate?: string;
  tenuousScore?: number;
  isSLA?: boolean;
  slaScore?: number;
  isServicePackage?: boolean;
  purchasedDate?: string;
  servicePackageScore?: number;
}

export interface ClientServiceProfileTenuousRecord extends EntityBase {
  startDate: string;
  endDate: string;
  duration: number;
  score: number;
}

export interface ClientSpecialHandlingNote extends EntityBase {
  text: string;
  accountOfferingId?: string;
  accountOfferingName?: string;
  serviceFunction?: ServiceFunctionType;
}

export interface Customization extends EntityBase {
  fromEmail?: string;
  logoAttachmentId?: string;
  brandingLogoId?: string;
  brandingEnabled?: boolean;
  authenticationPreferences: AuthenticationPreferences;
  chatEnabled?: boolean;
}

export type DepletionOrder = string[];

export interface Device extends EntityBase {
  token: string;
  deviceOSType?: DeviceOSType;
}

export interface AgencyClient extends EntityBase {
  clientId: string;
}

export interface AgentClientAccess extends EntityBase {
  agentId: string;
}

export interface AgentSupportAccess extends EntityBase {
  agentSupportContactId: string;
}

export interface Division extends EntityBase {
  name: string;
  subdivisions?: Subdivisions;
  shippingAddressId?: string;
  billingAddressId?: string;
  billingContactId?: string;
  primaryContactId?: string;
}

export interface DivisionContact extends EntityBase {
  contactId: string;
}

export interface Document extends EntityBase {
  name: string;
  documentType?: string;
  category: DocumentCategoryType;
  effectiveDate?: string;
  documentVersion?: string;
  documentAttachmentId?: string;
  description?: string;
  notes?: string;
  accountOffering?: string;
  source?: DocumentSourceType;
  displayToEmployees?: boolean;
  linkedBenefitPlanIds?: string[];
  letterServiceDocumentId?: string;
  letterServiceRequestList?: string[];
  firstMailDate?: string;
  lastMailDate?: string;
  eligibilityEventId?: string;
  dependentId?: string;
  communicationRequestId?: string;
  communicationTemplateId?: string;
  divisionId?: string;
  emailLinked?: boolean;
  displayName: string;
  firstViewedDate?: string;
  originalDocumentId?: string;
}

export interface DocumentDistribution extends EntityBase {
  distributionType: DistributionType;
  distributionId?: string;
}

export interface PublishedDocument {
  id?: string;
  parentId?: string;
  parentType?: ParentType;
  createdBy?: string;
  createdById?: string;
  created?: string;
  updatedBy?: string;
  updatedById?: string;
  updated?: string;
  docState?: string;
  docLastTransition?: string;
  name?: string;
  documentType?: string;
  documentVersion?: string;
  category?: string;
  effectiveDate?: string;
  documentAttachmentId?: string;
  description?: string;
  externalWorkflowId?: string;
  eventNotes?: string;
  transactionLockId?: string;
  notes?: string;
  accountOffering?: string;
  source?: string;
  docDistId?: string;
  distributionParentId?: string;
  distributionCreated?: string;
  distributionCreatedBy?: string;
  distributionCreatedById?: string;
  distributionCurrentState?: string;
  distributionId?: string;
  distributionType?: string;
}

export interface DocumentUploader {
  parentId?: string;
  uploader?: string;
  currentState?: string;
}

export type EmploymentHistory = EmploymentInfo[];

export interface EmployeeEligibilityClass extends EntityBase {
  clientClassId: number;
  effectiveDate: string;
  individualId: string;
  clientId: string;
}

export interface EmploymentInfo extends EntityBase {
  individualId: string;
  nonEmployee?: boolean;
  relatedEmployeeName?: string;
  relationToEmployee?: RelationshipType;
  relatedToId?: string;
  employeeId?: string;
  externalId?: string;
  primaryEmail?: string;
  hireDate: string;
  clientExternalId?: string;
  clientName?: string;
  individualName?: string;
  firstName?: string;
  lastName?: string;
  divisionId?: string;
  eligibilityClassId?: number;
  payrollScheduleName?: string;
  clientPayrollId?: string;
  subdivisionId?: string;
  terminationDate?: string;
  retired?: boolean;
  leavesOfAbsence?: LeaveOfAbsence[];
  hasLeavesOfAbsence?: number;
  claimConnexMemberId?: string;
  occupationTitle?: string;
  wage?: number;
  wageFrequency?: WageFrequencyType;
  averageHoursWorked?: number;
  hdhpCoverageStartDate?: string;
  hdhpCoverageEndDate?: string;
  healthPlanMemberId?: string;
  trackingDesignation?: string;
  originalHireDate?: string;
  transferredToDivisionId?: string;
  transferredFromDivisionId?: string;
}

export interface FundsTransferCriterion extends EntityBase {
  sourceId?: string;
  sourceType?: SourceType;
  sourcePaymentDetails?: PaymentDetails;
  destinationId?: string;
  destinationType?: DestinationType;
  amount?: number;
  frequency: FundsTransferFrequencyType;
  balance?: number;
  dayOfMonth?: number;
  startDate: string;
  endDate?: string;
  lastEntryDate?: string;
  nextEntryDate?: string;
  transferNote?: string;
  specialDisbursementType?: SpecialDisbursementType;
  specialContributionType?: SpecialContributionType;
  benefitPlanId?: string;
  benefitAccountId?: string;
  taxYear?: string;
  fundsTransferType?: FundsTransferType;
  quarterlyStartMonth?: number;
  convenienceFee?: number;
  sweepEndDate?: string;
}

export type FundsTransferCriteria = FundsTransferCriterion[];

export interface IndividualServiceProfile extends EntityBase {
  isVIP?: boolean;
  vipScore?: number;
}

export interface LeaveOfAbsence {
  startDate: string;
  returnDate?: string;
  leaveOfAbsenceType?: LeaveOfAbsenceType;
}

export interface PaymentDetails {
  checkDate?: string;
  checkNumber?: string;
  transactionId?: string;
  paymentId?: string;
  dateReceived?: string;
  amountReceived?: number;
  externalMemo?: string;
}

export interface Payroll extends EntityBase {
  name: string;
  frequency: PayrollFrequencyType;
  otherFrequency?: string;
}

export interface PayrollSchedule extends EntityBase {
  payrollId: string;
  payrollDates: string[];
  weeklyPayday?: number;
  monthlyPayday?: number;
  firstSemiMonthlyPayday?: number;
  secondSemiMonthlyPayday?: number;
  biWeeklyPaydate?: string;
  paydayOnLastDayOfMonth?: boolean;
  startDate?: string;
  endDate?: string;
  payPeriodStartOrEnd?: PayPeriodStartOrEndType;
}

export interface OfferingsEligibleData {
  offeringId: string;
  eventProfileSelections?: EventProfileSelection[];
  paymentPlanName: string;
  paymentPlanId: string;
  eligibleOfferingPriceData?: EligibleOfferingPriceData[];
  eligibilityStartDate: string;
  eligibilityEndDate?: string;
  lossOfCoverageDate?: string;
  fullAmountAdjusted?: boolean;
  planGracePeriodAfterElection?: number;
  offerSentDate?: string;
  offerResponseDate?: string;
  offerStartDate?: string;
  offerEndDate?: string;
  fullAdjustmentEndDate?: string;
  electionDueDate?: string;
  reviewErrors?: ReviewErrorType[];
  coveredPersons?: CoveredPerson[];
  conversionContact?: ConversionContact;
}

export interface SentCommunication {
  date?: string;
}

export interface Subdivision extends EntityBase {
  name: string;
}

export interface MessagesLinked {
  created?: string;
  currentState?: string;
  messageType?: ElectronicDeliveryMessageType;
}

export interface DocumentAction extends EntityBase {
  type: DocumentActionType;
  documentId: string;
  username: string;
  userType: DocumentActionUserType;
}

export interface ClientAccountManagement extends EntityBase {
  name: string;
  phoneExtension: number;
  email?: string;
  tpaPartner: TPAPartnerType;
}

export interface MspReportingRequest extends EntityBase {
  quarterName?: string;
  reportingPeriodStart?: string;
  reportingPeriodEnd?: string;
  reportingContext?: MspReportingRequestContext;
}

export interface MspReportingRequestContext {
  reportingOldestDate?: string;
  reportingDate?: string;
  RRE_ID?: string;
  RRE_TIN?: string;
  reportingStartDate?: string;
  reportingEndDate?: string;
  dob45yo?: string;
  reportingQuarter?: string;
  jobId?: string;
  priorReportingContext?: object;
  mspFileIds?: string[];
}

export interface MspReportingFile extends EntityBase {
  fileType: MspReportingFileType;
  fileName: string;
  s3Location?: string;
  headerTrailerRreId?: string;
  headerTrailerFileType?: string;
  headerTrailerFileDate?: string;
  trailerRecordCount?: number;
}

export interface MspReportingFileUrl {
  url?: string;
}

export interface MspInputFileLine extends EntityBase {
  medicareId?: string;
  beneficiarySurname?: string;
  beneficiaryFirstInitial?: string;
  beneficiaryDateOfBirth?: string;
  beneficiarySexCode?: string;
  dcn?: string;
  transactionType?: string;
  coverageType?: string;
  beneficiarySocialSecurityNumber?: string;
  effectiveDate?: string;
  terminationDate?: string;
  relationshipCode?: string;
  policyHolderFirstName?: string;
  policyHolderLastName?: string;
  policyHolderSsn?: string;
  employerSize?: string;
  groupPolicyNumber?: string;
  individualPolicyNumber?: string;
  employeeCoverageElection?: string;
  employeeStatus?: string;
  employerTin?: string;
  insurerTpaTin?: string;
  nationalHealthPlan?: string;
  rxInsuredIdNumber?: string;
  rxGroupNumber?: string;
  rxPcn?: string;
  rxBinNumber?: string;
  rxTollFreeNumber?: string;
  personCode?: string;
  smallEmployerExceptionMedicareId?: string;
  overrideCode?: string;
  benefitPlanId?: string;
  benefitAccountId?: string;
  aciType?: string;
  aciId?: string;
  aciParentId?: string;
  clientId?: string;
  lockedByCMS?: boolean;
  lastAcceptedAddInputLineId?: string;
  lastAcceptedAddResponseLineId?: string;
  lastAcceptedUpdateInputLineId?: string;
  lastAcceptedUpdateResponseLineId?: string;
}

export interface MspResponseFileLine extends EntityBase {
  rreAssignedDcn?: string;
  transactionType?: string;
  coverageType?: string;
  originalCoverageEffectiveDate?: string;
  originalCoverageTerminationDate?: string;
  bcrcDcn?: string;
  medicareId?: string;
  entitlementReason?: string;
  mspEffectiveDate?: string;
  mspTerminationDate?: string;
  splitEntitlementIndicator?: string;
  lateSubmissionIndicator?: string;
  dispositionCode?: string;
  dispositionDate?: string;
  errorCode1?: string;
  errorCode2?: string;
  errorCode3?: string;
  errorCode4?: string;
  rxDispositionCode?: string;
  rxDispositionDate?: string;
  rxErrorCode1?: string;
  rxErrorCode2?: string;
  rxErrorCode3?: string;
  rxErrorCode4?: string;
  beneficiarySurname?: string;
  beneficiaryFirstInitial?: string;
  beneficiaryDateOfBirth?: string;
  beneficiarySexCode?: string;
  relationshipCode?: string;
  medicareBeneficiaryDateOfDeath?: string;
}

export interface EligibilityEvent extends EntityBase {
  eventType: string;
  eventDate: string;
  effectiveDate?: string;
  incurredByProfileId: string;
  incurredById?: string;
  clientId: string;
  paymentAccountGroupId?: string;
  electionDueDate?: string;
  offerSentDate?: string;
  firstResponseDate?: string;
  lastResponseDate?: string;
  hasTakeover?: boolean;
  takeoverPaidThroughDate?: string;
  hideFrom?: HideFromType;
  originalEligibilityEventId?: string;
  modificationType?: string;
  replacesEEId?: string;
  sendOfferLetter?: boolean;
  divisionId?: string;
}

export interface EnrichableEligibilityEvent extends EligibilityEvent {
  meta?: EligibilityEventMeta;
}

export type EnrichableEligibilityEvents = EnrichableEligibilityEvent[];

export interface EligibilityEventMeta {
  eligibilityStartDate: string;
  eligibilityEndDate?: string;
  eventSummaryState?: EventSummaryStateType;
  inactivationHold?: string;
  isModification: boolean;
}

export interface EligibleEligibilityEvent {
  eligibilityEventId: string;
  paymentAccountGroupId?: string;
  readOnly: boolean;
  eventType: string;
  eventDate: string;
  incurredByName?: string;
  offeringsEligibleData: OfferingsEligibleData[];
  eventProfiles?: EventProfileData[];
  clientId?: string;
  individualId?: string;
  electionDueDate: string;
  lastDayToPayInitialObligations?: string;
  eligibilityEventState: string;
  offerSentDate?: string;
  firstResponseDate?: string;
  lastResponseDate?: string;
  earliestElectionDueDate?: string;
  serviceOfferingId?: string;
  displayName?: string;
}

export interface EligibilityEventOffering extends EntityBase {
  paymentPlanId: string;
  individualId: string;
  includedParties?: string[];
  lossOfCoverageDate?: string;
  eligibilityStartDate: string;
  eligibilityEndDate?: string;
  externalNotes?: string;
  reviewErrors?: ReviewErrorType[];
  pricingModelId?: string;
  pricingOptionTypes?: PricingOptionType[];
  fsaBenefitAccountId?: string;
  fsaAnnualElectionAmount?: number;
  fsaFundingYtd?: number;
  fsaDisbursementsYtd?: number;
}

export interface EligibilityEventElectionData {
  planId: string;
  offerResponseDate: string;
  electedProfileIds: string[];
}

export interface ConversionContact {
  carrierName: string;
  contactInfo: string;
}

export interface CoveredPerson {
  includedEventOfferingParty?: object;
  fullName?: string;
  relationshipType?: RelationshipType;
  primaryAddress?: Address;
  addressSameAsIndividual?: boolean;
  dateOfBirth?: string;
  profileType?: ProfileType;
  profileId?: string;
}

export interface EventProfileData {
  eventProfileId?: string;
  fullName?: string;
  relationshipType?: RelationshipType;
  primaryAddress?: Address;
  addressSameAsIndividual?: boolean;
  dateOfBirth?: string;
  profileType?: ProfileType;
  profileId?: string;
}

export interface EventProfileSelection {
  eventProfileId?: string;
  elected?: boolean;
  available?: boolean;
  fullName?: string;
  isIndividual?: boolean;
}

export interface EligibleOfferingPriceData {
  fullAmount?: number;
  adjustmentAmount?: number;
  feeAmount?: number;
  basePrice?: number;
  tier?: string;
  firstAdjustedDate?: string;
  lastAdjustedDate?: string;
  adjustedForFullDuration?: boolean;
  populateFullAdjustmentEndDate?: boolean;
  firstFullPaymentDate?: string;
}

export interface OfferingPrice extends EntityBase {
  tier?: string;
  basePrice: number;
  priceType?: string;
  feeAmount?: number;
  feePercentage?: number;
  feeType?: FeeType;
  feeRoundingType?: RoundingType;
  amountDue?: number;
  startMonthProrated?: number;
  endMonthProrated?: number;
  priceKey: string;
  includeFeesInCalculation?: boolean;
  includeSurchargeInCalculation?: boolean;
  adjustmentAmount?: number;
  adjustmentPercentage?: number;
  adjustmentCalculation?: AdjustmentCalculation;
  adjustmentDurationMonths?: number;
  adjustmentEndDate?: string;
  adjustmentDurationType?: AdjustmentDurationType;
  pricingEffectiveDate: string;
  pricingModelId: string;
  previousOfferingPriceId?: string;
  surcharges?: Surcharge[];
}

export interface FilteredOfferingPriceResponse {
  offeringPrice?: OfferingPrice;
  excessCoverage?: boolean;
  profileIds?: string[];
}

export interface ConvenienceFee {
  feeAmount?: number;
}

export interface ConvenienceFeeCalculationDefinition {
  paymentMethodType: ConvenienceFeePaymentType;
  calculationType: ConvenienceFeeCalculationType;
  amount: number;
}

export interface EligibilityEventOfferingEnriched extends EligibilityEventOffering {
  fsaMeta?: EligibilityEventOfferingFsaMeta;
  planPayees?: PlanPayeeInfo[];
}

export interface EligibilityEventOfferingFsaMeta {
  managedByTpa?: boolean;
  benefitAccountId?: string;
  electionAmount?: number;
  fundingYtd?: number;
  disbursementsYtd?: number;
}

export interface FundsTransferOptions {
  Disbursements?: FundsTransferGroupOption[];
  FeePayments?: FundsTransferGroupOption[];
  Contributions?: FundsTransferGroupOption[];
  SpecialContributions?: FundsTransferGroupOption[];
  Adjustments?: FundsTransferGroupOption[];
  Payments?: FundsTransferGroupOption[];
  FeeSweeps?: FundsTransferGroupOption[];
  BinSweeps?: FundsTransferGroupOption[];
  BureauTransfers?: FundsTransferGroupOption[];
}

export interface FundsTransferGroupOption {
  fundsTransferType?: FundsTransferType;
  specialDisbursementTypes?: SpecialDisbursementType[];
  specialContributionType?: string;
  fundingSourceType?: FundingSourceType;
  sourceName?: string;
  sourceId?: string;
  sourceType?: SourceType;
  destinationType?: DestinationType;
  destinationName?: string;
  destinationId?: string;
  achSecCodeIndicator?: string;
  achFrequencyIndicator?: string;
  fundsTransferGroup?: FundsTransferGroup;
  paymentSourceType?: string;
  fundsTransferFrequencyTypes?: FundsTransferFrequencyType[];
  benefitPlanId?: string;
  parentType?: string;
  requireStartToProcessed?: boolean;
}

export interface BenefitAccountCategory {
  benefitPlanId?: string;
  benefitAccountId?: string;
  name?: string;
  disburseWithoutRequest?: boolean;
  giveBackAccount?: boolean;
  benefitAccountType?: string;
  optForCobraCoverage?: boolean;
  fundingSource?: string;
  secondaryBureauId?: string;
  benefitPlanPaymentSourceId?: string;
  isOpenEnded?: boolean;
  hasPODorBudgetedFunding?: boolean;
  benefitAccountState?: string;
  specialDisbursementTypes?: string[];
  specialContributionTypes?: string[];
  participantFundingMethods?: string[];
  contributionPosting?: string;
  hasActiveOpenEndedSchedule?: boolean;
  benefitPlanType?: string;
  clientFundingMethods?: string[];
  enterpriseSolutionType?: EnterpriseSolutionType;
}

export interface PaymentPlanRemittanceInfo {
  individualId?: string;
  paymentAccountId?: string;
  clientID?: string;
  paymentAccountGroupId?: string;
  obligationId?: string;
  lineItemId?: string;
  tier?: string;
  paymentPlanId?: string;
  planName?: string;
  obligationState?: string;
  lineItemAmount?: number;
  basePrice?: number;
  feeAmount?: number;
  planPayeeInfos?: PlanPayeeInfo[];
  surcharges?: Surcharge[];
  amountType?: ObligationAmountType;
}

export interface PlanPayeeInfo {
  id?: string;
  payeeId?: string;
  percentType?: PercentType;
  percent?: number;
  percentSubtype?: string;
  payeeType?: string;
  payeeName?: string;
}

export interface Surcharge {
  amount: number;
  surchargeType: string;
  calculationMethod: FeeType;
  percentage?: number;
}

export interface PayeeDistributionDetail {
  remittancePaymentMethodAccountId?: string;
  planId?: string;
  payeeId?: string;
  paymentSourceId?: string;
  payeeName?: string;
}

export interface AuthenticationPreferences {
  pux: PUXAuthPreferences;
  clux: CLUXAuthPreferences;
}

export interface PUXAuthPreferences extends AuthPreferences {
  stepUpRequired: boolean;
}

export interface CLUXAuthPreferences extends AuthPreferences {}

export interface AgencyAuthPreferences extends EntityBase {
  minRequiredMfaCount: number;
  offeredMfaMethods: MFAMethod[];
}

export interface AuthPreferences {
  minRequiredMfaCount: number;
  offeredMfaMethods: MFAMethod[];
}

export interface AgentProduction {
  id: string;
  parentId: string;
  parentType: ParentType;
  created: string;
  currentState?: string;
  tpa: TPAPartnerType;
  providerTascId: string;
  circleStatus: string;
  totalRenewalValue: number;
  previousYearProduction: number;
  currentYearProduction: number;
}

export interface AgentProductionByOffering {
  id: string;
  parentId: string;
  parentType: ParentType;
  created: string;
  currentState?: string;
  tpa: TPAPartnerType;
  providerTascId: string;
  productName: string;
  totalRenewalValue: number;
  previousYearProduction: number;
  currentYearProduction: number;
}

export interface IndividualCommunicationSummary {
  documentId?: string;
  originalDocumentId?: string;
  documentName?: string;
  documentState?: string;
  recipientName?: string;
  status?: string;
  distributionMethod?: string;
  createdDate?: string;
  lastEmailDate?: string;
  lastMailDate?: string;
  firstSentDate?: DeliverySentDate;
  lastSentDate?: DeliverySentDate;
  firstViewedDate?: string;
  messagesLinked?: MessagesLinked[];
  allowedActions?: AllowedCommunicationActions[];
  displayName?: string;
  numberOfReminders?: number;
  remindersSent?: number;
  actionRequired?: boolean;
}

export interface DeliverySentDate {
  date?: string;
  method?: string;
}

export interface Criteria {
  key?: string;
  value?: string;
  matchType?: MatchType;
  chainType?: ChainType;
  groupCriteria?: GroupCriteria[];
}

export interface Error {
  message?: string;
  fields?: object;
}

export interface ErrorBody {
  errors?: object;
}

export interface GroupCriteria {
  key?: string;
  value?: string;
  matchType?: MatchType;
  chainType?: ChainType;
  groupCriteria?: GroupCriteria[];
}

export interface ConvenienceFeeCriteria {
  convenienceFeePaymentType: ConvenienceFeePaymentType;
  paymentAmount: number;
  clientId?: string;
  parentId?: string;
}

export interface PingResponse {
  serverTime: ServerTime;
  services?: Service[];
}

export type SearchCriteria = Criteria[];

export interface Service {
  name?: string;
  serverTime?: string;
}

export interface DisplayLetter extends Document {
  sentTo?: string;
}

export type ServerTime = string;

export type AdvanceSetups = AdvanceSetup[];

export type ApiKeys = ApiKey[];

export type CcxEnrollments = CcxEnrollment[];

export type ClientDivisions = ClientDivision[];

export type ClientServiceProfiles = ClientServiceProfile[];

export type ClientServiceProfilePriorities = ClientServiceProfilePriority[];

export type ClientServiceProfileTenuousRecords = ClientServiceProfileTenuousRecord[];

export type ClientSpecialHandlingNotes = ClientSpecialHandlingNote[];

export type Customizations = Customization[];

export type Devices = Device[];

export type AgencyClients = AgencyClient[];

export type AgentClientAccesses = AgentClientAccess[];

export type AgentSupportAccesses = AgentSupportAccess[];

export type Divisions = Division[];

export type DivisionContacts = DivisionContact[];

export type Documents = Document[];

export type DocumentDistributions = DocumentDistribution[];

export type DocumentUploaders = DocumentUploader[];

export type EmployeeEligibilityClasses = EmployeeEligibilityClass[];

export type IndividualServiceProfiles = IndividualServiceProfile[];

export type MspReportingRequests = MspReportingRequest[];

export type MspReportingFiles = MspReportingFile[];

export type MspInputFileLines = MspInputFileLine[];

export type MspResponseFileLines = MspResponseFileLine[];

export type Payrolls = Payroll[];

export type PayrollSchedules = PayrollSchedule[];

export type PublishedDocuments = PublishedDocument[];

export type Subdivisions = Subdivision[];

export type DocumentActions = DocumentAction[];

export type AgentProductions = AgentProduction[];

export type AgentProductionByOfferings = AgentProductionByOffering[];

export interface CommandBase {
  id?: string;
  eventCorrelationId?: string;
  jobId?: string;
  producerId?: string;
  sequenceId?: number;
  version?: number;
  type?: string;
  created?: string;
  createdBy?: string;
  createdById?: string;
}

export interface EntityBase {
  id?: string;
  parentId?: string;
  parentType?: ParentType;
  version?: number;
  created?: string;
  createdBy?: string;
  createdById?: string;
  updated?: string;
  updatedBy?: string;
  updatedById?: string;
  currentState?: string;
  lastTransition?: string;
  externalWorkflowId?: string;
  eventNotes?: string;
  transactionLockId?: string;
}

export enum EnterpriseSolutionType {
  DirectPaymentICHRA = 'DirectPaymentICHRA',
  EmployeePremiumAccount = 'EmployeePremiumAccount',
  None = 'None',
  PremiumProtectionAccount = 'PremiumProtectionAccount',
  ReimbursementICHRA = 'ReimbursementICHRA',
  ReimbursementNESP = 'ReimbursementNESP',
}

export enum AdvanceSetupCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  ActiveToOnHold = 'ActiveToOnHold',
  ActiveToRemoved = 'ActiveToRemoved',
  InactiveToActive = 'InactiveToActive',
  OnHoldToActive = 'OnHoldToActive',
  OnHoldToOnHold = 'OnHoldToOnHold',
  StartToActive = 'StartToActive',
}

export enum ApiKeyCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  ActiveToRemoved = 'ActiveToRemoved',
  InactiveToRemoved = 'InactiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum CcxEnrollmentCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  ActiveToRemoved = 'ActiveToRemoved',
  InactiveToActive = 'InactiveToActive',
  InactiveToInactive = 'InactiveToInactive',
  InactiveToRemoved = 'InactiveToRemoved',
  StartToActive = 'StartToActive',
  StartToInactive = 'StartToInactive',
}

export enum ClientServiceProfileCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  StartToActive = 'StartToActive',
}

export enum ClientServiceProfilePriorityCommandType {
  ActiveToActive = 'ActiveToActive',
  StartToActive = 'StartToActive',
}

export enum ClientServiceProfileTenuousRecordCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  StartToActive = 'StartToActive',
}

export enum ClientSpecialHandlingNoteCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  StartToActive = 'StartToActive',
}

export enum CustomizationCommandType {
  ActiveToActive = 'ActiveToActive',
  StartToActive = 'StartToActive',
}

export enum DeviceCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToRemoved = 'ActiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum AgencyClientCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  ActiveToRemoved = 'ActiveToRemoved',
  InactiveToActive = 'InactiveToActive',
  InactiveToInactive = 'InactiveToInactive',
  InactiveToRemoved = 'InactiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum AgentClientAccessCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToRemoved = 'ActiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum AgentSupportAccessCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToRemoved = 'ActiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum AgencyAuthPreferencesCommandType {
  ActiveToActive = 'ActiveToActive',
  StartToActive = 'StartToActive',
}

export enum DivisionCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToRemoved = 'ActiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum DivisionContactCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToRemoved = 'ActiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum DocumentCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToArchived = 'ActiveToArchived',
  ActiveToRemoved = 'ActiveToRemoved',
  ActiveToRequestedMail = 'ActiveToRequestedMail',
  ArchivedToActive = 'ArchivedToActive',
  ArchivedToRemoved = 'ArchivedToRemoved',
  MailErrorToRequestedMail = 'MailErrorToRequestedMail',
  MailedToRequestedMail = 'MailedToRequestedMail',
  RequestedDocumentToActive = 'RequestedDocumentToActive',
  RequestedDocumentToError = 'RequestedDocumentToError',
  RequestedDocumentToRequestedMail = 'RequestedDocumentToRequestedMail',
  RequestedMailToActive = 'RequestedMailToActive',
  RequestedMailToMailError = 'RequestedMailToMailError',
  RequestedMailToMailed = 'RequestedMailToMailed',
  StartToActive = 'StartToActive',
  StartToRequestedDocument = 'StartToRequestedDocument',
  StartToRequestedMail = 'StartToRequestedMail',
}

export enum DocumentDistributionCommandType {
  PublishedToPublished = 'PublishedToPublished',
  PublishedToUnpublished = 'PublishedToUnpublished',
  StartToPublished = 'StartToPublished',
  UnpublishedToPublished = 'UnpublishedToPublished',
}

export enum EmployeeEligibilityClassCommandType {
  PendingDeleteToDeleted = 'PendingDeleteToDeleted',
  PendingToDeleted = 'PendingToDeleted',
  PendingToPending = 'PendingToPending',
  PendingToPendingDelete = 'PendingToPendingDelete',
  PendingToProcessed = 'PendingToProcessed',
  PendingToRemoved = 'PendingToRemoved',
  ProcessedToDeleted = 'ProcessedToDeleted',
  ProcessedToPending = 'ProcessedToPending',
  ProcessedToPendingDelete = 'ProcessedToPendingDelete',
  ProcessedToRemoved = 'ProcessedToRemoved',
  StartToPending = 'StartToPending',
}

export enum EmploymentInfoCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  ActiveToLeaveOfAbsence = 'ActiveToLeaveOfAbsence',
  ActiveToRemoved = 'ActiveToRemoved',
  ActiveToRetired = 'ActiveToRetired',
  ActiveToTerminated = 'ActiveToTerminated',
  AnyToEnrollCcx = 'AnyToEnrollCcx',
  InactiveToActive = 'InactiveToActive',
  InactiveToInactive = 'InactiveToInactive',
  LeaveOfAbsenceToActive = 'LeaveOfAbsenceToActive',
  LeaveOfAbsenceToInactive = 'LeaveOfAbsenceToInactive',
  LeaveOfAbsenceToLeaveOfAbsence = 'LeaveOfAbsenceToLeaveOfAbsence',
  LeaveOfAbsenceToRetired = 'LeaveOfAbsenceToRetired',
  LeaveOfAbsenceToTerminated = 'LeaveOfAbsenceToTerminated',
  ProcessOnHoldToRemoveHold = 'ProcessOnHoldToRemoveHold',
  RemovedToActive = 'RemovedToActive',
  RetiredToActive = 'RetiredToActive',
  RetiredToRetired = 'RetiredToRetired',
  StartToActive = 'StartToActive',
  StartToLeaveOfAbsence = 'StartToLeaveOfAbsence',
  StartToRetired = 'StartToRetired',
  StartToTerminated = 'StartToTerminated',
  TerminatedToActive = 'TerminatedToActive',
  TerminatedToTerminated = 'TerminatedToTerminated',
}

export enum FundsTransferCriterionCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToBlocked = 'ActiveToBlocked',
  ActiveToCancelled = 'ActiveToCancelled',
  ActiveToProcessed = 'ActiveToProcessed',
  BlockedToActive = 'BlockedToActive',
  BlockedToCancelled = 'BlockedToCancelled',
  BlockedToPending = 'BlockedToPending',
  PendingToActive = 'PendingToActive',
  PendingToBlocked = 'PendingToBlocked',
  PendingToCancelled = 'PendingToCancelled',
  StartToActive = 'StartToActive',
  StartToPending = 'StartToPending',
  StartToProcessed = 'StartToProcessed',
}

export enum IndividualServiceProfileCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  StartToActive = 'StartToActive',
}

export enum PayrollCommandType {
  CreatedToCreated = 'CreatedToCreated',
  CreatedToInUse = 'CreatedToInUse',
  CreatedToRemoved = 'CreatedToRemoved',
  InUseToCreated = 'InUseToCreated',
  InUseToInUse = 'InUseToInUse',
  StartToCreated = 'StartToCreated',
}

export enum PayrollScheduleCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToInactive = 'ActiveToInactive',
  ActiveToRemoved = 'ActiveToRemoved',
  InactiveToActive = 'InactiveToActive',
  InactiveToInactive = 'InactiveToInactive',
  InactiveToRemoved = 'InactiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum DocumentActionCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToRemoved = 'ActiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum ClientAccountManagementCommandType {
  ActiveToActive = 'ActiveToActive',
  ActiveToRemoved = 'ActiveToRemoved',
  StartToActive = 'StartToActive',
}

export enum MspReportingRequestCommandType {
  AnyToError = 'AnyToError',
  PendingCmsResponseToProcessingCmsResponse = 'PendingCmsResponseToProcessingCmsResponse',
  PendingPhase2ToPhase2 = 'PendingPhase2ToPhase2',
  PendingPhase3ToPhase3 = 'PendingPhase3ToPhase3',
  Phase1ToPendingPhase2 = 'Phase1ToPendingPhase2',
  Phase2ToPendingPhase3 = 'Phase2ToPendingPhase3',
  Phase3ToReady = 'Phase3ToReady',
  PreProcessingErrorToProcessingCmsResponse = 'PreProcessingErrorToProcessingCmsResponse',
  ProcessingCmsResponseToPreProcessingError = 'ProcessingCmsResponseToPreProcessingError',
  ProcessingCmsResponseToProcessingError = 'ProcessingCmsResponseToProcessingError',
  ProcessingCmsResponseToQuarterComplete = 'ProcessingCmsResponseToQuarterComplete',
  ReadyToPendingCmsResponse = 'ReadyToPendingCmsResponse',
  RequestedToPhase1 = 'RequestedToPhase1',
  StartToRequested = 'StartToRequested',
}

export enum MspReportingFileCommandType {
  AnyToError = 'AnyToError',
  AnyToRemoved = 'AnyToRemoved',
  PendingUploadToUploaded = 'PendingUploadToUploaded',
  PreparingToReady = 'PreparingToReady',
  ProcessingToProcessed = 'ProcessingToProcessed',
  ReadyForProcessingToProcessing = 'ReadyForProcessingToProcessing',
  ReadyToDownloaded = 'ReadyToDownloaded',
  StartToPendingUpload = 'StartToPendingUpload',
  StartToPreparing = 'StartToPreparing',
  UploadedToReadyForProcessing = 'UploadedToReadyForProcessing',
}

export enum MspResponseFileLineCommandType {
  AnyToError = 'AnyToError',
  CreatedToProcessed = 'CreatedToProcessed',
  StartToCreated = 'StartToCreated',
}

export enum EligibilityEventCommandType {
  AnyToNeedsReview = 'AnyToNeedsReview',
  AnyToProfileSynchronized = 'AnyToProfileSynchronized',
  DraftToDraft = 'DraftToDraft',
  DraftToIneligible = 'DraftToIneligible',
  DraftToModified = 'DraftToModified',
  DraftToOffered = 'DraftToOffered',
  DraftToRemoved = 'DraftToRemoved',
  ExpiredToRemoved = 'ExpiredToRemoved',
  IneligibleToRemoved = 'IneligibleToRemoved',
  ModifiedToModified = 'ModifiedToModified',
  ModifiedToRemoved = 'ModifiedToRemoved',
  ModifiedToReplaced = 'ModifiedToReplaced',
  NeedsReviewToModified = 'NeedsReviewToModified',
  NeedsReviewToNeedsReview = 'NeedsReviewToNeedsReview',
  NeedsReviewToOffered = 'NeedsReviewToOffered',
  NeedsReviewToRemoved = 'NeedsReviewToRemoved',
  OfferedToExpired = 'OfferedToExpired',
  OfferedToOffered = 'OfferedToOffered',
  OfferedToRemoved = 'OfferedToRemoved',
  OfferedToResponded = 'OfferedToResponded',
  ReplacedToRemoved = 'ReplacedToRemoved',
  RespondedToRemoved = 'RespondedToRemoved',
  StartToDraft = 'StartToDraft',
  StartToModified = 'StartToModified',
}

export enum EligibilityEventOfferingCommandType {
  IncludedToIncluded = 'IncludedToIncluded',
  IncludedToNeedsReview = 'IncludedToNeedsReview',
  IncludedToRemoved = 'IncludedToRemoved',
  IncludedToStaged = 'IncludedToStaged',
  NeedsReviewToIncluded = 'NeedsReviewToIncluded',
  NeedsReviewToNeedsReview = 'NeedsReviewToNeedsReview',
  NeedsReviewToRejected = 'NeedsReviewToRejected',
  NeedsReviewToRemoved = 'NeedsReviewToRemoved',
  NeedsReviewToStaged = 'NeedsReviewToStaged',
  OverspentToNeedsReview = 'OverspentToNeedsReview',
  OverspentToRemoved = 'OverspentToRemoved',
  RejectedToRemoved = 'RejectedToRemoved',
  RejectedToStaged = 'RejectedToStaged',
  StagedToIncluded = 'StagedToIncluded',
  StagedToOverspent = 'StagedToOverspent',
  StagedToRejected = 'StagedToRejected',
  StagedToRemoved = 'StagedToRemoved',
  StagedToStaged = 'StagedToStaged',
  StartToNeedsReview = 'StartToNeedsReview',
  StartToStaged = 'StartToStaged',
}

export enum OfferingPriceCommandType {
  IncludedToIncluded = 'IncludedToIncluded',
  IncludedToRejected = 'IncludedToRejected',
  IncludedToRemoved = 'IncludedToRemoved',
  RejectedToIncluded = 'RejectedToIncluded',
  RejectedToRejected = 'RejectedToRejected',
  RejectedToRemoved = 'RejectedToRemoved',
  StartToIncluded = 'StartToIncluded',
}

export enum AdvanceSetupState {
  Active = 'Active',
  Inactive = 'Inactive',
  OnHold = 'OnHold',
  Removed = 'Removed',
  Start = 'Start',
}

export enum ApiKeyState {
  Active = 'Active',
  Inactive = 'Inactive',
  Removed = 'Removed',
}

export enum CcxEnrollmentState {
  Active = 'Active',
  Inactive = 'Inactive',
  Removed = 'Removed',
  Start = 'Start',
}

export enum ClientServiceProfileState {
  Active = 'Active',
  Inactive = 'Inactive',
  Start = 'Start',
}

export enum ClientServiceProfilePriorityState {
  Active = 'Active',
  Start = 'Start',
}

export enum ClientServiceProfileTenuousRecordState {
  Active = 'Active',
  Inactive = 'Inactive',
  Start = 'Start',
}

export enum ClientSpecialHandlingNoteState {
  Active = 'Active',
  Inactive = 'Inactive',
  Start = 'Start',
}

export enum CustomizationState {
  Active = 'Active',
  Start = 'Start',
}

export enum DeviceState {
  Active = 'Active',
  Removed = 'Removed',
  Start = 'Start',
}

export enum AgencyClientState {
  Active = 'Active',
  Inactive = 'Inactive',
  Removed = 'Removed',
}

export enum AgencyAuthPreferencesState {
  Active = 'Active',
  Start = 'Start',
}

export enum AgentClientAccessState {
  Active = 'Active',
  Removed = 'Removed',
}

export enum AgentSupportAccessState {
  Active = 'Active',
  Removed = 'Removed',
}

export enum DivisionState {
  Active = 'Active',
  Removed = 'Removed',
  Start = 'Start',
}

export enum DivisionContactState {
  Active = 'Active',
  Removed = 'Removed',
  Start = 'Start',
}

export enum DocumentState {
  Active = 'Active',
  Archived = 'Archived',
  Error = 'Error',
  MailError = 'MailError',
  Mailed = 'Mailed',
  Removed = 'Removed',
  RequestedDocument = 'RequestedDocument',
  RequestedMail = 'RequestedMail',
}

export enum DocumentDistributionState {
  Published = 'Published',
  Start = 'Start',
  Unpublished = 'Unpublished',
}

export enum EmployeeEligibilityClassState {
  Deleted = 'Deleted',
  Pending = 'Pending',
  PendingDelete = 'PendingDelete',
  Processed = 'Processed',
  Removed = 'Removed',
}

export enum EmploymentInfoState {
  Active = 'Active',
  Inactive = 'Inactive',
  LeaveOfAbsence = 'LeaveOfAbsence',
  ProcessOnHold = 'ProcessOnHold',
  RemoveHold = 'RemoveHold',
  Removed = 'Removed',
  Retired = 'Retired',
  Start = 'Start',
  Terminated = 'Terminated',
}

export enum FundsTransferCriterionState {
  Active = 'Active',
  Blocked = 'Blocked',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Error = 'Error',
  ErrorPendingRetry = 'ErrorPendingRetry',
  Pending = 'Pending',
  Processed = 'Processed',
}

export enum IndividualServiceProfileState {
  Active = 'Active',
  Inactive = 'Inactive',
  Start = 'Start',
}

export enum PayrollState {
  Created = 'Created',
  InUse = 'InUse',
  Removed = 'Removed',
  Start = 'Start',
}

export enum PayrollScheduleState {
  Active = 'Active',
  Inactive = 'Inactive',
  Removed = 'Removed',
  Start = 'Start',
}

export enum DocumentActionState {
  Active = 'Active',
  Removed = 'Removed',
}

export enum ClientAccountManagementState {
  Active = 'Active',
  Removed = 'Removed',
  Start = 'Start',
}

export enum MspReportingRequestState {
  Error = 'Error',
  PendingCmsResponse = 'PendingCmsResponse',
  PendingPhase2 = 'PendingPhase2',
  PendingPhase3 = 'PendingPhase3',
  Phase1 = 'Phase1',
  Phase2 = 'Phase2',
  Phase3 = 'Phase3',
  PreProcessingError = 'PreProcessingError',
  ProcessingCmsResponse = 'ProcessingCmsResponse',
  ProcessingError = 'ProcessingError',
  QuarterComplete = 'QuarterComplete',
  Ready = 'Ready',
  Removed = 'Removed',
  Requested = 'Requested',
}

export enum MspReportingFileState {
  Downloaded = 'Downloaded',
  Error = 'Error',
  PendingUpload = 'PendingUpload',
  Preparing = 'Preparing',
  Processed = 'Processed',
  Processing = 'Processing',
  Ready = 'Ready',
  ReadyForProcessing = 'ReadyForProcessing',
  Removed = 'Removed',
  Uploaded = 'Uploaded',
}

export enum MspInputFileLineState {
  Active = 'Active',
  NotSent = 'NotSent',
  Removed = 'Removed',
}

export enum MspTinInputFileLineState {
  Active = 'Active',
  Removed = 'Removed',
}

export enum MspResponseFileLineState {
  Created = 'Created',
  Error = 'Error',
  Processed = 'Processed',
  Removed = 'Removed',
}

export enum EligibilityEventState {
  Draft = 'Draft',
  Expired = 'Expired',
  Ineligible = 'Ineligible',
  Modified = 'Modified',
  NeedsReview = 'NeedsReview',
  Offered = 'Offered',
  ProfileSynchronized = 'ProfileSynchronized',
  Removed = 'Removed',
  Replaced = 'Replaced',
  Responded = 'Responded',
}

export enum EligibilityEventOfferingState {
  Included = 'Included',
  NeedsReview = 'NeedsReview',
  Overspent = 'Overspent',
  Rejected = 'Rejected',
  Removed = 'Removed',
  Staged = 'Staged',
}

export enum OfferingPriceState {
  Included = 'Included',
  Rejected = 'Rejected',
  Removed = 'Removed',
}

export enum AcquisitionMethodType {
  New = 'New',
  Purchased = 'Purchased',
}

export enum DeviceOSType {
  Android = 'Android',
  iOS = 'iOS',
}

export enum DistributionType {
  BusinessAffiliates = 'BusinessAffiliates',
  Clients = 'Clients',
  Individuals = 'Individuals',
}

export enum ElectronicDeliveryMessageType {
  Adhoc = 'Adhoc',
  Initial = 'Initial',
  Reminder = 'Reminder',
}

export enum EventSummaryStateType {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Declined = 'Declined',
  Draft = 'Draft',
  Expired = 'Expired',
  Ineligible = 'Ineligible',
  Offered = 'Offered',
  Responded = 'Responded',
}

export enum ParentType {
  ADVANCE = 'ADVANCE',
  AGENCY = 'AGENCY',
  AGENCY_CLIENT = 'AGENCY_CLIENT',
  AGENT = 'AGENT',
  AGENT_SUPPORT_CONTACT = 'AGENT_SUPPORT_CONTACT',
  BENEFIT_PLAN = 'BENEFIT_PLAN',
  BUREAU = 'BUREAU',
  CHARITY = 'CHARITY',
  CLIENT = 'CLIENT',
  CLIENT_CAUSE = 'CLIENT_CAUSE',
  CLIENT_CONTACT = 'CLIENT_CONTACT',
  DEPENDENT = 'DEPENDENT',
  DIVISION = 'DIVISION',
  DOCUMENT = 'DOCUMENT',
  ELIGIBILITY_EVENT = 'ELIGIBILITY_EVENT',
  ELIGIBILITY_EVENT_OFFERING = 'ELIGIBILITY_EVENT_OFFERING',
  EMPLOYMENT_INFO = 'EMPLOYMENT_INFO',
  INDIVIDUAL = 'INDIVIDUAL',
  INSTANCE = 'INSTANCE',
  MSP_REPORTING_FILE = 'MSP_REPORTING_FILE',
  MSP_REPORTING_REQUEST = 'MSP_REPORTING_REQUEST',
  PAYEE = 'PAYEE',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
}

export enum AddressType {
  Billing = 'Billing',
  Other = 'Other',
  Primary = 'Primary',
  Shipping = 'Shipping',
}

export enum WageFrequencyType {
  Annual = 'Annual',
  BiWeekly = 'Bi-Weekly',
  Hourly = 'Hourly',
  Monthly = 'Monthly',
  SemiMonthly = 'Semi-Monthly',
  Weekly = 'Weekly',
}

export enum DestinationType {
  BFA = 'BFA',
  BureauCashAccount = 'BureauCashAccount',
  CAB = 'CAB',
  CRA = 'CRA',
  Charity = 'Charity',
  Check = 'Check',
  ClientCause = 'ClientCause',
  ClientDirect = 'ClientDirect',
  ClientDirectInvestment = 'ClientDirectInvestment',
  ClientToPlan = 'ClientToPlan',
  ClientToPlanInvestment = 'ClientToPlanInvestment',
  DesignatedParticipantHoldingAccount = 'DesignatedParticipantHoldingAccount',
  IAB = 'IAB',
  Individual = 'Individual',
  PYAB = 'PYAB',
  ParticipantDirect = 'ParticipantDirect',
  ParticipantDirectFundingBenefitPlan = 'ParticipantDirectFundingBenefitPlan',
  ParticipantDirectFundingInvestmentBenefitAccount = 'ParticipantDirectFundingInvestmentBenefitAccount',
  ParticipantToClient = 'ParticipantToClient',
  ParticipantToClientInvestment = 'ParticipantToClientInvestment',
  PaymentPlan = 'PaymentPlan',
  PaymentSource = 'PaymentSource',
  RemittanceStagingAccount = 'RemittanceStagingAccount',
  SecondaryBureau = 'SecondaryBureau',
  UndesignatedParticipantHoldingAccount = 'UndesignatedParticipantHoldingAccount',
  UnfundedBenefitAccount = 'UnfundedBenefitAccount',
}

export enum AllowedCommunicationActions {
  Download = 'Download',
  Regenerate = 'Regenerate',
  SendEmail = 'SendEmail',
  SendMail = 'SendMail',
}

export enum ConvenienceFeePaymentType {
  ACH = 'ACH',
  Card = 'Card',
  Check = 'Check',
}

export enum ConvenienceFeeCalculationType {
  Flat = 'Flat',
  Percentage = 'Percentage',
}

export enum SourceType {
  BAB = 'BAB',
  BenefitAccountForDisburseWithoutRequest = 'BenefitAccountForDisburseWithoutRequest',
  BinAccount = 'BinAccount',
  BinCorrection = 'BinCorrection',
  BinException = 'BinException',
  BureauCashAccount = 'BureauCashAccount',
  BureauFeeAccount = 'BureauFeeAccount',
  CAB = 'CAB',
  CDAF = 'CDAF',
  CRA = 'CRA',
  CardForced = 'CardForced',
  ClientCause = 'ClientCause',
  DesignatedParticipantHoldingAccount = 'DesignatedParticipantHoldingAccount',
  GiveBackAccount = 'GiveBackAccount',
  IAB = 'IAB',
  PPTAB = 'PPTAB',
  PYAB = 'PYAB',
  Payee = 'Payee',
  PaymentSource = 'PaymentSource',
  SecondaryBureau = 'SecondaryBureau',
  ServiceOffering = 'ServiceOffering',
  UndesignatedParticipantHoldingAccount = 'UndesignatedParticipantHoldingAccount',
}

export enum ServiceFunctionType {
  Audit = 'Audit',
  BAMComplianceFunction = 'BAM Compliance Function',
  BenefitCard = 'Benefit Card',
  ClientAdmin = 'Client Admin',
  ClientInvoicing = 'Client Invoicing',
  EnrollmentandATC = 'Enrollment and ATC',
  FinalizationReconciliation = 'Finalization/Reconciliation',
  Funding = 'Funding',
  InvestmentAdministration = 'Investment Administration',
  Management = 'Management',
  ParticipantIndividualAccount = 'Participant Individual Account',
  ParticipantRequestProcessing = 'Participant Request Processing',
  Reporting = 'Reporting',
  UserAccess = 'User Access',
}

export enum DocumentCategoryType {
  Client = 'Client',
  InternalTemplate = 'InternalTemplate',
  TASC = 'TASC',
}

export enum DocumentSourceType {
  External = 'External',
  Internal = 'Internal',
}

export enum FundsTransferFrequencyType {
  BiWeekly26 = 'BiWeekly26',
  Monthly = 'Monthly',
  OneTime = 'OneTime',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly',
  WhenBalanceReached = 'WhenBalanceReached',
}

export enum LeaveOfAbsenceType {
  FullBenefits = 'FullBenefits',
  NoBenefits = 'NoBenefits',
}

export enum PayrollFrequencyType {
  BiWeekly24 = 'BiWeekly24',
  BiWeekly26 = 'BiWeekly26',
  Monthly = 'Monthly',
  Other = 'Other',
  SemiMonthly = 'SemiMonthly',
  Weekly = 'Weekly',
}

export enum PayPeriodStartOrEndType {
  End = 'End',
  Start = 'Start',
}

export enum PriorityClientType {
  NewACQ = 'NewACQ',
  NewTraditional = 'NewTraditional',
  NotApplicable = 'NotApplicable',
}

export enum SpecialDisbursementType {
  Death = 'Death',
  Disability = 'Disability',
  ExcessContribution = 'ExcessContribution',
  Fee = 'Fee',
  GivingRefund = 'GivingRefund',
  ProhibitedDisbursement = 'ProhibitedDisbursement',
  Takeover = 'Takeover',
  TransferToCustodian = 'TransferToCustodian',
  TransferToParticipant = 'TransferToParticipant',
}

export enum SpecialContributionType {
  Adjustment = 'Adjustment',
  COBRA = 'COBRA',
  FundedRollover = 'FundedRollover',
  Interest = 'Interest',
  InvestmentInterest = 'InvestmentInterest',
  ManualRequestRepayment = 'ManualRequestRepayment',
  ParticipantCardRefund = 'ParticipantCardRefund',
  ParticipantRefund = 'ParticipantRefund',
  ParticipantRepayment = 'ParticipantRepayment',
  TransferFromCustodian = 'TransferFromCustodian',
  TransferFromParticipant = 'TransferFromParticipant',
  UnfundedRollover = 'UnfundedRollover',
  Wellness = 'Wellness',
}

export enum DocumentActionType {
  Accepted = 'Accepted',
}

export enum DocumentActionUserType {
  Admin = 'Admin',
  Agent = 'Agent',
  AgentSupportContact = 'AgentSupportContact',
  Client = 'Client',
  Participant = 'Participant',
}

export enum TPAPartnerType {
  BASIC = 'BASIC',
  TASC = 'TASC',
}

export enum FundsTransferType {
  ACHConvenienceFeeSweepAutomated = 'ACHConvenienceFeeSweepAutomated',
  ACHConvenienceFeeSweepManual = 'ACHConvenienceFeeSweepManual',
  BenefitAccountAdjustment = 'BenefitAccountAdjustment',
  BenefitAccountCardFunding = 'BenefitAccountCardFunding',
  BenefitAccountToMyCashWithoutRequest = 'BenefitAccountToMyCashWithoutRequest',
  BureauBenefitAccountCardFunding = 'BureauBenefitAccountCardFunding',
  BureauContributionDrawAutomated = 'BureauContributionDrawAutomated',
  BureauContributionDrawManual = 'BureauContributionDrawManual',
  BureauDisbursementDrawManual = 'BureauDisbursementDrawManual',
  BureauTransferFromSecondaryBureauAutomated = 'BureauTransferFromSecondaryBureauAutomated',
  BureauTransferFromSecondaryBureauManual = 'BureauTransferFromSecondaryBureauManual',
  BureauTransferToSecondaryBureauAutomated = 'BureauTransferToSecondaryBureauAutomated',
  BureauTransferToSecondaryBureauManual = 'BureauTransferToSecondaryBureauManual',
  CABBalanceAdjustment = 'CABBalanceAdjustment',
  CABDisbursementToClient = 'CABDisbursementToClient',
  CDAFDisbursementToClient = 'CDAFDisbursementToClient',
  CDAFToBenefitAccount = 'CDAFToBenefitAccount',
  CardConvenienceFeeSweepAutomated = 'CardConvenienceFeeSweepAutomated',
  CardConvenienceFeeSweepManual = 'CardConvenienceFeeSweepManual',
  CharityAdjustment = 'CharityAdjustment',
  ClientCABFunding = 'ClientCABFunding',
  ClientCABFundingToCDAF = 'ClientCABFundingToCDAF',
  ClientCABToCDAF = 'ClientCABToCDAF',
  ClientFeeAssessmentSweepAutomated = 'ClientFeeAssessmentSweepAutomated',
  ClientFeeAssessmentSweepManual = 'ClientFeeAssessmentSweepManual',
  ClientPaymentSourceToBenefitAccount = 'ClientPaymentSourceToBenefitAccount',
  ClientPaymentSourceToInvestmentBenefitAccount = 'ClientPaymentSourceToInvestmentBenefitAccount',
  ClientRemittanceAccountAdjustment = 'ClientRemittanceAccountAdjustment',
  CustodialInvestmentRolloverToBenefitAccount = 'CustodialInvestmentRolloverToBenefitAccount',
  DesignatedHoldingAccountAdjustment = 'DesignatedHoldingAccountAdjustment',
  DonationDisbursementToCharity = 'DonationDisbursementToCharity',
  FundedConversionRolloverToBenefitAccount = 'FundedConversionRolloverToBenefitAccount',
  GivebackAccountToCharity = 'GivebackAccountToCharity',
  HSAOrphanFeeSweepAutomated = 'HSAOrphanFeeSweepAutomated',
  HSAOrphanFeeSweepManual = 'HSAOrphanFeeSweepManual',
  IndividualDonorAdvisedFundToMyCashRefund = 'IndividualDonorAdvisedFundToMyCashRefund',
  IndividualGivingAccountToMyCashRefund = 'IndividualGivingAccountToMyCashRefund',
  InvestmentBenefitAccountAdjustment = 'InvestmentBenefitAccountAdjustment',
  InvestmentInterestToBenefitAccount = 'InvestmentInterestToBenefitAccount',
  MyCashAdjustment = 'MyCashAdjustment',
  MyCashDesignatedHoldingAccountAdjustment = 'MyCashDesignatedHoldingAccountAdjustment',
  MyCashFeeSweepAutomated = 'MyCashFeeSweepAutomated',
  MyCashFeeSweepManual = 'MyCashFeeSweepManual',
  MyCashToBenefitAccount = 'MyCashToBenefitAccount',
  MyCashToBenefitAccountCardRefund = 'MyCashToBenefitAccountCardRefund',
  MyCashToBureauBenefitAccount = 'MyCashToBureauBenefitAccount',
  MyCashToPaymentSource = 'MyCashToPaymentSource',
  MyCashUndesignatedHoldingAccountAdjustment = 'MyCashUndesignatedHoldingAccountAdjustment',
  ParticipantACHToBenefitAccount = 'ParticipantACHToBenefitAccount',
  ParticipantACHToInvestmentBenefitAccount = 'ParticipantACHToInvestmentBenefitAccount',
  ParticipantCheckToBenefitAccount = 'ParticipantCheckToBenefitAccount',
  ParticipantCheckToInvestmentBenefitAccount = 'ParticipantCheckToInvestmentBenefitAccount',
  ParticipantInvestmentRolloverToBenefitAccount = 'ParticipantInvestmentRolloverToBenefitAccount',
  ParticipantPaymentSourceToBenefitAccountRefund = 'ParticipantPaymentSourceToBenefitAccountRefund',
  ParticipantPaymentSourceToMyCash = 'ParticipantPaymentSourceToMyCash',
  PayeeRemittanceAccountAdjustment = 'PayeeRemittanceAccountAdjustment',
  PaymentPlanAdminFeeSweepAutomated = 'PaymentPlanAdminFeeSweepAutomated',
  PaymentPlanAdminFeeSweepManual = 'PaymentPlanAdminFeeSweepManual',
  PaymentPlanAdminSurchargeFeeSweepAutomated = 'PaymentPlanAdminSurchargeFeeSweepAutomated',
  PaymentPlanAdminSurchargeFeeSweepManual = 'PaymentPlanAdminSurchargeFeeSweepManual',
  PaymentPlanNSFFeeSweepAutomated = 'PaymentPlanNSFFeeSweepAutomated',
  PaymentPlanNSFFeeSweepManual = 'PaymentPlanNSFFeeSweepManual',
  PaymentPlanToPayee = 'PaymentPlanToPayee',
  PptACHToPptHoldingAccount = 'PptACHToPptHoldingAccount',
  PptCardToPptHoldingAccount = 'PptCardToPptHoldingAccount',
  PptCheckToPptHoldingAccount = 'PptCheckToPptHoldingAccount',
  PptDesignatedHoldingAccountInactivation = 'PptDesignatedHoldingAccountInactivation',
  PptDesignatedHoldingAccountToPptHoldingAccount = 'PptDesignatedHoldingAccountToPptHoldingAccount',
  PptUndesignatedHoldingAccountInactivation = 'PptUndesignatedHoldingAccountInactivation',
  PptUndesignatedHoldingAccountToPptHoldingAccount = 'PptUndesignatedHoldingAccountToPptHoldingAccount',
  PptUndesignatedHoldingAccountToPptHoldingAccountPending = 'PptUndesignatedHoldingAccountToPptHoldingAccountPending',
  RemittanceDistributionToClient = 'RemittanceDistributionToClient',
  RemittanceDistributionToPayee = 'RemittanceDistributionToPayee',
  RemittanceStagingAccountAdjustment = 'RemittanceStagingAccountAdjustment',
  SweepBinCorrection = 'SweepBinCorrection',
  SweepBinException = 'SweepBinException',
  SweepBinPayeeAccount = 'SweepBinPayeeAccount',
  SweepCardForced = 'SweepCardForced',
  SweepPaymentProcessorBinAccount = 'SweepPaymentProcessorBinAccount',
  TakeoverBenefitAccountToMyCashWithoutRequest = 'TakeoverBenefitAccountToMyCashWithoutRequest',
  UndesignatedHoldingAccountAdjustment = 'UndesignatedHoldingAccountAdjustment',
  UnfundedBenefitAccountAdjustment = 'UnfundedBenefitAccountAdjustment',
  UnfundedConversionRolloverToBenefitAccount = 'UnfundedConversionRolloverToBenefitAccount',
}

export enum FundsTransferGroup {
  Adjustment = 'Adjustment',
  BinSweep = 'BinSweep',
  BureauTransfer = 'BureauTransfer',
  Contribution = 'Contribution',
  Disbursement = 'Disbursement',
  FeePayment = 'FeePayment',
  FeeSweep = 'FeeSweep',
  Payment = 'Payment',
  SpecialContribution = 'SpecialContribution',
  System = 'System',
}

export enum ReviewErrorType {
  DEPENDENT_ADDED = 'DEPENDENT_ADDED',
  DEPENDENT_MODIFIED = 'DEPENDENT_MODIFIED',
  DEPENDENT_REMOVED = 'DEPENDENT_REMOVED',
  INCOMPATIBLE_ELIGIBILITY_EVENT_OFFERINGS = 'INCOMPATIBLE_ELIGIBILITY_EVENT_OFFERINGS',
  INDIVIDUAL_MODIFIED = 'INDIVIDUAL_MODIFIED',
  PLAN_ADDED = 'PLAN_ADDED',
  PLAN_NO_LONGER_OFFERABLE = 'PLAN_NO_LONGER_OFFERABLE',
  PRICING_CHANGE_DEPENDENT_COVERAGE_LOSS = 'PRICING_CHANGE_DEPENDENT_COVERAGE_LOSS',
  PRICING_CHANGE_NEGATIVE_FEE = 'PRICING_CHANGE_NEGATIVE_FEE',
  PRICING_CHANGE_NO_COVERAGE_AVAILABLE = 'PRICING_CHANGE_NO_COVERAGE_AVAILABLE',
  PRICING_MODIFIED = 'PRICING_MODIFIED',
  PRICING_REQUIRED = 'PRICING_REQUIRED',
}

export enum ObligationAmountType {
  Base = 'Base',
  Fee = 'Fee',
  Surcharge = 'Surcharge',
}

export enum AdjustmentDurationType {
  CustomEndDate = 'CustomEndDate',
  NumberOfMonths = 'NumberOfMonths',
  UntilCoverageEnds = 'UntilCoverageEnds',
}

export enum AdjustmentCalculation {
  Flat = 'Flat',
  Percent = 'Percent',
}

export enum FeeType {
  Flat = 'Flat',
  Percentage = 'Percentage',
}

export enum PricingOptionType {
  Age = 'Age',
  FSA = 'FSA',
  Fee = 'Fee',
  Gender = 'Gender',
  IndividuallyRated = 'IndividuallyRated',
  SmokingStatus = 'SmokingStatus',
  Tier = 'Tier',
}

export enum RelationshipType {
  Child = 'Child',
  DomesticPartner = 'DomesticPartner',
  ExSpouse = 'ExSpouse',
  Other = 'Other',
  Spouse = 'Spouse',
  SurvivingSpouse = 'SurvivingSpouse',
}

export enum RoundingType {
  Down = 'Down',
  Standard = 'Standard',
  Up = 'Up',
}

export enum TransferParentGroup {
  BUREAU = 'BUREAU',
  CHARITY = 'CHARITY',
  CLIENT = 'CLIENT',
  INDIVIDUAL = 'INDIVIDUAL',
  PAYEE = 'PAYEE',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
  SYSTEM = 'SYSTEM',
}

export enum FundingSourceType {
  ClientDirect = 'ClientDirect',
  ClientToPlan = 'ClientToPlan',
  ParticipantDirect = 'ParticipantDirect',
  ParticipantToClient = 'ParticipantToClient',
}

export enum ProfileType {
  DEPENDENT = 'DEPENDENT',
  INDIVIDUAL = 'INDIVIDUAL',
}

export enum MspReportingFileType {
  MSPInput = 'MSPInput',
  MSPResponse = 'MSPResponse',
  TINReference = 'TINReference',
}

export enum HideFromType {
  All = 'All',
  ClientOnly = 'ClientOnly',
  None = 'None',
  ParticipantAndClientOnly = 'ParticipantAndClientOnly',
  ParticipantOnly = 'ParticipantOnly',
}

export enum SystemModificationType {
  PriceChange = 'PriceChange',
  System = 'System',
}

export enum PercentType {
  Base = 'Base',
  Fee = 'Fee',
  Surcharge = 'Surcharge',
}


export enum MFAMethod {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export enum ChainType {
  AND = 'AND',
  OR = 'OR',
}

export enum MatchType {
  BETWEEN = 'BETWEEN',
  CONTAINS = 'CONTAINS',
  EXACT = 'EXACT',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  IN = 'IN',
  IS_NULL = 'IS_NULL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
  NOT = 'NOT',
  NOT_CONTAINS = 'NOT_CONTAINS',
  NOT_IN = 'NOT_IN',
  NOT_STARTS_WITH = 'NOT_STARTS_WITH',
  STARTS_WITH = 'STARTS_WITH',
}
